module.exports = __webpack_public_path__ + "e62a217c.svg";